@use '../../scss/global' as *;
@use 'themes';

// ================================================================ //
// -- Local Variables

// ================================================================ //
// -- Component Styles

:host {
  display: block;

  .fluid-expand-container {
    position: relative;
    display: block;
    overflow: hidden;

    .dynamic-content {
      overflow-y: auto;
      transition: max-height 0.75s ease-in-out;
    }
  }
}
